import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-stat-card',
    template: `
        <div class="card summary flex justify-content-between m-2">
            <div>
                <span class="title">{{title}}</span>
                <span class="detail">{{description}}</span>
            </div>
            <div class="flex align-items-center">
                <span class="count p-2" [class]="styleClass">{{value| number}}</span>
            </div>
        </div>
    `,
    styles: [
        `
            .summary {
                height: 75px;
            }
            .title {
                font-size: 20px;
            }

            .detail {
                color: #a4a4a4;
                display: block;
                margin-top: 10px;
            }

            .count {
                color: #ffffff;
                font-size: 24px;
                border-radius: 4px;
            }
        `
    ]
})
export class StatCardComponent {
    @Input() title = '-';
    @Input() description = '-';
    @Input() value = 0;
    @Input() styleClass: string;
}
